export default __webpack_public_path__ + "static/media/mode-34.6ac6de12.svg";